<template>
  <a :href="item.link">
    <div
      class="
        mdc-card
        blog
        border-b
        no-hover no-shadow no-ripple
        pb-4
        lg:border-0 lg:pb-0
        rounded-3xl
      "
    >
      <div class="mdc-card__primary-action" tabindex="0">
        <div
          v-if="showImage"
          class="mdc-card__media mdc-card__media--16-9 rounded-3xl"
          :style="`background-image: url(${item.image})`"
        ></div>
        <div class="card__primary">
          <p class="card__date mt-6 mb-2">
            {{ item.scheduled_post }}
          </p>
          <span class="card__title text-xl font-bold leading-snug dark mb-3">{{
            item.title
          }}</span>
        </div>
        <p class="card__secondary purplish-grey">
          {{ item.short_description }}
        </p>
      </div>
      <div class="mdc-card__actions min-h-full mt-2 p-0">
        <div class="mdc-card__action-buttons">
          <button class="btn-blog-more mdc-button topaz cursor-pointer p-0 text-icon">
            <span class="mdc-button__label">Leer más</span>
            <i class="material-icons mdc-button__icon" aria-hidden="true"
              >chevron_right</i
            >
          </button>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mdc-card{
    border-style: none;
}
</style>